import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from "react-router-dom";
import Home from "./components/Home";
import Profile from "./components/Profile";
import CoursePreview from "./components/CoursePreview";
import Enrolment from "./components/Enrolment";
import Lesson from "./components/Enrolment/Lesson";
import CourseGift from "./components/Gifts/CourseGift";
import PassGift from "./components/Gifts/PassGift";
import GiftPage from "./components/Pages/Gift";
import CoursePay from "./components/Payments/CoursePay";
import SubscriptionPay from "./components/Payments/SubscriptionPay";
import GiftPay from "./components/Payments/GiftPay";
import GiftSuccess from "./components/Pages/GiftSuccess";
import PassSuccess from "./components/Pages/PassSuccess";
import { RenewalOffer } from "./components/Pages/RenewalOffer";
import About from "./components/Pages/About";
import Faq from "./components/Pages/Faq";
import TeamPlans from "./components/Pages/TeamPlans";
import Pricing from "./components/Pages/Pricing";
import Workshops from "./components/Pages/Workshops";
import Contact from "./components/Pages/Contact";
import Privacy from "./components/Pages/Privacy";
import Conditions from "./components/Pages/Conditions";
import Accessibility from "./components/Pages/Accessibility";
import Cookies from "./components/Pages/Cookies";
import NewBadges from "./components/Pages/NewBadges";
import DynamicLayoutRoute from "./DynamicLayoutRoute";
import UpgradePay from "./components/Payments/UpgradePay";
import RenewalPay from "./components/Payments/RenewalPay";
import Referral from "./components/Pages/Referral";
import UserSetup from "./components/Pages/UserSetup";
import Certification from "./components/Certifications";
import TeamManagement from "./components/TeamManagement";
import PaymentSuccessfull from "./components/Payments/PaymentSuccessful";
import ForgotPassword from "./components/Passwords/ForgotPassword";
import ResetPassword from "./components/Passwords/ResetPassword";
import Brands from "./components/Brands";
import ThoughtLeaderProfile from "./components/ThoughtLeaders/Profile";
import SkillAreas from "./components/SkillAreas";
import BlogIndex from "./components/BlogPosts/Index";
import BlogPostShow from "./components/BlogPosts/Show";
import BlogAuthor from "./components/BlogPosts/AuthorPage";
import PodcastsIndex from "./components/Podcasts/Index";
import NewslettersIndex from "./components/Newsletters/Index";
import RoryQuotesFinder from "./components/RoryQuotes/Finder";
import RoryQuotesTop from "./components/RoryQuotes/Top";
import RoryQuotesShow from "./components/RoryQuotes/Show";
import HalloweenPage from "./components/Halloween/Page";
import AllCourses from "./components/AllCourses";
import DynamicPages from "./components/DynamicPages";
import Chat from "./components/Chat";
import Login from "./components/Login";
import CommunityNew from "./components/CommunityNew";
import NotificationsPage from "./components/Notifications";
import InvoicesPage from "./components/Invoices";
import Permissions from "./components/Permissions";
import { CannesReviews } from "./components/CannesReviews";
import CourseOverview from "./components/Enrolment/CourseOverview";

const ScrollToTop = withRouter(({ location }: any) => {
  React.useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null;
});

const Routes = () => (
  <Router>
    <ScrollToTop />
    <Switch>
      <DynamicLayoutRoute exact path="/" component={Home} />
      <DynamicLayoutRoute
        exact
        path="/user/setup"
        component={UserSetup}
        layout="setup"
        showRecentNotifications={false}
      />
      <DynamicLayoutRoute exact path="/profile" component={Profile} />
      <DynamicLayoutRoute
        exact
        path="/notifications"
        component={NotificationsPage}
      />
      <DynamicLayoutRoute exact path="/invoices" component={InvoicesPage} />
      <DynamicLayoutRoute
        exact
        path="/courses/:slug"
        component={CoursePreview}
      />
      <DynamicLayoutRoute
        exact
        path="/courses/:slug/upcoming"
        mode="upcoming"
        component={CoursePreview}
      />
      <DynamicLayoutRoute
        exact
        layout="payment"
        path="/courses/:slug/gift"
        component={CourseGift}
      />
      <DynamicLayoutRoute
        exact
        layout="payment"
        path="/passes/:slug/gift"
        component={PassGift}
      />
      <DynamicLayoutRoute exact path="/gift" component={GiftPage} />
      <DynamicLayoutRoute
        exact
        path={["/courses/:slug/pay", "/pay/course"]}
        component={CoursePay}
        layout="payment"
      />
      <DynamicLayoutRoute
        exact
        path="/passes/:slug/pay"
        component={SubscriptionPay}
        layout="payment"
      />
      <DynamicLayoutRoute
        exact
        path="/gift/:token/pay"
        component={GiftPay}
        layout="payment"
      />
      <DynamicLayoutRoute
        exact
        path={["/pass/:slug/renew", "/pass/:slug/renew"]}
        component={RenewalPay}
        layout="payment"
      />
      <DynamicLayoutRoute
        exact
        path="/pass/:slug/upgrade"
        component={UpgradePay}
        layout="payment"
      />
      <DynamicLayoutRoute
        exact
        path="/gift/:token/success"
        component={GiftSuccess}
      />
      <DynamicLayoutRoute
        exact
        path="/passes/:slug/success"
        component={PassSuccess}
      />
      <DynamicLayoutRoute exact path="/about" component={About} />
      <DynamicLayoutRoute exact path="/faqs" component={Faq} />
      <DynamicLayoutRoute exact path="/for_business" component={TeamPlans} />
      <DynamicLayoutRoute exact path="/team_plans" component={TeamPlans} />
      <DynamicLayoutRoute exact path="/pricing" component={Pricing} />
      <DynamicLayoutRoute exact path="/workshops" component={Workshops} />
      <DynamicLayoutRoute exact path="/contact" component={Contact} />
      <DynamicLayoutRoute exact path="/privacy" component={Privacy} />
      <DynamicLayoutRoute
        exact
        path={["/cookies", "/cookie_policy"]}
        component={Cookies}
      />
      <DynamicLayoutRoute
        exact
        path="/accessibility"
        component={Accessibility}
      />
      <DynamicLayoutRoute
        exact
        path={["/conditions", "/terms"]}
        component={Conditions}
      />
      <DynamicLayoutRoute exact path="/referrals" component={Referral} />
      <DynamicLayoutRoute exact path="/community" component={CommunityNew} />
      <DynamicLayoutRoute exact path="/permissions" component={Permissions} />
      <DynamicLayoutRoute
        exact
        path="/achievements/badges"
        component={NewBadges}
      />
      <DynamicLayoutRoute
        exact
        path="/enrolments/:enrolmentId"
        component={CourseOverview}
        layout="lesson"
      />
      <DynamicLayoutRoute
        exact
        path="/enrolments/:enrolmentId/resources"
        component={CourseOverview}
        mode="resources"
        layout="lesson"
      />
      <DynamicLayoutRoute
        exact
        path="/enrolments/:enrolmentId/lives"
        component={CourseOverview}
        mode="lives"
        layout="lesson"
      />
      <DynamicLayoutRoute
        exact
        path={[
          "/enrolments/:enrolmentId/questions/:questionId",
          "/enrolments/:enrolmentId/questions/:questionId/answer",
          "/enrolments/:enrolmentId/questions/:questionId/answer/new",
        ]}
        component={Lesson}
        layout="lesson"
        showRecentNotifications={false}
      />
      <DynamicLayoutRoute
        exact
        path="/enrolments/:enrolmentId/questions/:questionId/answers/:answerId/votes"
        component={Lesson}
        mode="answerUpvotes"
        layout="lesson"
        showRecentNotifications={false}
      />
      <DynamicLayoutRoute
        exact
        path="/enrolments/:enrolmentId/certificate"
        component={Lesson}
        mode="certificate"
        layout="lesson"
        showRecentNotifications={false}
      />
      <DynamicLayoutRoute
        exact
        path="/teams/:slug/manage"
        component={TeamManagement}
        showRecentNotifications={false}
      />
      <DynamicLayoutRoute
        exact
        path="/certifications/:id"
        component={Certification}
      />
      <DynamicLayoutRoute
        exact
        path="/payments/successful/:userActivationStatus"
        component={PaymentSuccessfull}
        layout="lesson-hide-signin-button"
      />
      <DynamicLayoutRoute
        exact
        path="/session/password_resets/new"
        component={ForgotPassword}
      />
      <DynamicLayoutRoute
        exact
        path="/session/password_resets/:id/edit"
        component={ResetPassword}
      />
      <DynamicLayoutRoute exact path="/brands/:slug" component={Brands} />
      <DynamicLayoutRoute
        exact
        path="/thought-leaders/:slug"
        component={ThoughtLeaderProfile}
      />
      <DynamicLayoutRoute
        exact
        path="/skill-areas/:slug"
        component={SkillAreas}
      />
      <DynamicLayoutRoute exact path="/blog" component={BlogIndex} />
      {/* Before /blog/:slug, or an author slug is looked up as a post. */}
      <DynamicLayoutRoute exact path="/blog/authors/:slug" component={BlogAuthor} />
      <DynamicLayoutRoute exact path="/blog/:slug" component={BlogPostShow} />
      <DynamicLayoutRoute exact path="/podcasts" component={PodcastsIndex} />
      <DynamicLayoutRoute exact path="/halloween" component={HalloweenPage} />
      <DynamicLayoutRoute exact path="/newsletters" component={NewslettersIndex} />
      <DynamicLayoutRoute exact path="/rory-quotes" component={RoryQuotesFinder} />
      <DynamicLayoutRoute exact path="/rory-quotes/top" component={RoryQuotesTop} />
      {/* After the named page, or "top" would be looked up as a quote. */}
      <DynamicLayoutRoute exact path="/rory-quotes/:slug" component={RoryQuotesShow} />
      <DynamicLayoutRoute exact path="/courses" component={AllCourses} />
      <DynamicLayoutRoute
        exact
        path={[
          "/page/:pageSlug",
          "/brands/:slug/:pageSlug",
          "/courses/:slug/:pageSlug",
        ]}
        component={DynamicPages}
      />
      <DynamicLayoutRoute
        exact
        path="/chat"
        component={Chat}
        layout="payment"
      />
      <DynamicLayoutRoute
        exact
        path="/login"
        component={Login}
        layout="setup"
      />
      <DynamicLayoutRoute
        exact
        path="/subscriptions/renewal_offer"
        component={RenewalOffer}
      />
      <Route exact path="/cannes_lions_love" component={CannesReviews} />
    </Switch>
  </Router>
);

export default Routes;
